import { createContext, Dispatch, SetStateAction } from "react";

type WizardType = {
  answers: Record<string, any>;
  isNotProvide: boolean;
  addPhoto: {
    isPhotoAdded: boolean;
    isLoading: boolean;
    isSkippedWithoutPhoto: boolean;
  };
  stepper: Record<
    number,
    {
      isActive: boolean;
      isCompleted: boolean;
      number: number;
      title: string;
    }
  >;
};

type WizardStore = [WizardType, Dispatch<SetStateAction<WizardType>>];

const WizardStore = createContext<WizardStore>([] as unknown as WizardStore);

export { type WizardType, WizardStore };
